(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const section = document.querySelector(".dostupnost-wrapper");
    if (!section) return;

    // --- IKONY A CTA LABEL / URL --------------------------------------
    const iconUrlMap = {
      tv: section.dataset.iconTv || "",
      net: section.dataset.iconNet || "",
      phone: section.dataset.iconPhone || "",
      combo: section.dataset.iconCombo || "",
      sat: section.dataset.iconSat || ""
    };

    const ctaLabel    = section.dataset.ctaLabel    || "Objednať";
    const ctaUrlCombo = section.dataset.ctaUrlCombo || "";
    const ctaUrlTv    = section.dataset.ctaUrlTv    || "";
    const ctaUrlSat   = section.dataset.ctaUrlSat   || "";

    function getIconForProduct(product) {
      if (!product) return "";

      // satelitná TV podľa kódu
      if (product.code && product.code.toUpperCase() === "TV-SAT") {
        return iconUrlMap.sat;
      }

      switch (product.group_id) {
        case 1:
          return iconUrlMap.net;   // internet
        case 2:
          return iconUrlMap.phone; // telefón
        case 3:
          return iconUrlMap.tv;    // IPTV
        default:
          return "";
      }
    }

    // URL podľa typu služby – máme len 3 objednávacie produkty: combo, tv, sat
    function getCtaUrlForType(typeKey) {
      if (typeKey === "combo") {
        return ctaUrlCombo || "";
      }
      if (typeKey === "tv") {
        return ctaUrlTv || "";
      }
      if (typeKey === "sat") {
        return ctaUrlSat || "";
      }
      // internet / phone nemajú vlastné tlačidlo
      return "";
    }

    // --- INPUTY --------------------------------------------------------
    const dostupnostCityInput = section.querySelector(".dostupnost-city-input");
    const dostupnostCitySuggestions = section.querySelector(".dostupnost-city-suggestions");
    const dostupnostCityId = section.querySelector(".dostupnost-city-id");

    const dostupnostStreetInput = section.querySelector(".dostupnost-street-input");
    const dostupnostStreetSuggestions = section.querySelector(".dostupnost-street-suggestions");
    const dostupnostStreetId = section.querySelector(".dostupnost-street-id");

    const dostupnostHouseInput = section.querySelector(".dostupnost-house-input");
    const dostupnostHouseSuggestions = section.querySelector(".dostupnost-house-suggestions");
    const dostupnostHouseId = section.querySelector(".dostupnost-house-id");

    const dostupnostResults = section.querySelector(".dostupnost-results");

    // --- STAV ----------------------------------------------------------
    let citySearchTimer = null;
    let streetSearchTimer = null;
    let houseSearchTimer = null;

    let currentCityId = null;
    let currentCityStreetCount = 0;
    let currentStreetId = null;

    // --- POMOCNÉ FUNKCIE ----------------------------------------------
    function clearCitySuggestions() {
      dostupnostCitySuggestions.innerHTML = "";
      dostupnostCitySuggestions.style.display = "none";
    }

    function clearStreetSuggestions() {
      dostupnostStreetSuggestions.innerHTML = "";
      dostupnostStreetSuggestions.style.display = "none";
    }

    function clearHouseSuggestions() {
      dostupnostHouseSuggestions.innerHTML = "";
      dostupnostHouseSuggestions.style.display = "none";
    }

    function createSuggestionItem(title, secondaryText) {
      const li = document.createElement("li");
      li.innerHTML = `
        <div class="dostupnost-item">
          <div class="dostupnost-item-title">${title}</div>
          ${
            secondaryText
              ? `<div class="dostupnost-item-county">${secondaryText}</div>`
              : ""
          }
        </div>
      `;
      return li;
    }

    function setResultsPlaceholder(text) {
      dostupnostResults.innerHTML = `<p class="dostupnost-results-placeholder">${text}</p>`;
    }

    // --- RENDER SLUŽIEB -----------------------------------------------
    function renderAvailabilityResult(addressData) {
      if (!addressData || !addressData.products) {
        setResultsPlaceholder("V tejto lokalite momentálne neevidujeme dostupné služby.");
        return;
      }

      const ready = Array.isArray(addressData.products.ready)
        ? addressData.products.ready
        : [];
      const planned = Array.isArray(addressData.products.planed)
        ? addressData.products.planed
        : [];

      if (!ready.length && !planned.length) {
        setResultsPlaceholder("V tejto lokalite momentálne neevidujeme dostupné služby.");
        return;
      }

      function groupByGroupId(list) {
        const map = {};
        list.forEach((p) => {
          const gid = p.group_id || 0;
          if (!map[gid]) map[gid] = [];
          map[gid].push(p);
        });
        return map;
      }

      const readyByGroup = groupByGroupId(ready);

      const cards = [];

      const readyInternet = (readyByGroup[1] || [])[0] || null;
      const readyPhone    = (readyByGroup[2] || [])[0] || null;
      const readyTvList   = readyByGroup[3] || [];

      let hasSatReady = false;
      let hasIptvReady = false;

      // TV a SAT z API
      readyTvList.forEach((tvProd) => {
        const isSat = tvProd.code && tvProd.code.toUpperCase() === "TV-SAT";
        if (isSat) {
          hasSatReady = true;
          cards.push({
            product: tvProd,
            typeKey: "sat",
            isCombo: false
          });
        } else {
          hasIptvReady = true;
          cards.push({
            product: tvProd,
            typeKey: "tv",
            isCombo: false
          });
        }
      });

      // Internet – len na zobrazenie ako súčasť služby
      if (readyInternet) {
        cards.push({
          product: readyInternet,
          typeKey: "internet",
          isCombo: false
        });
      }

      // Telefón – len na zobrazenie ako súčasť služby
      if (readyPhone) {
        cards.push({
          product: readyPhone,
          typeKey: "phone",
          isCombo: false
        });
      }

      // Ak je SAT, ale nie IPTV – pridáme natvrdo ANTIK TV ako alternatívu
      if (hasSatReady && !hasIptvReady) {
        const syntheticIptv = {
          name: "ANTIK TV",
          description: "Digitálna televízia",
          code: "TV-IPTV",
          group_id: 3
        };
        cards.push({
          product: syntheticIptv,
          typeKey: "tv",
          isCombo: false
        });
      }

      // Combo (3P) – len ak máme internet + aspoň jednu TV + telefón
      let hasComboCard = false;
      if (readyInternet && readyPhone && (hasSatReady || hasIptvReady)) {
        const comboProduct = {
          name: "Všetko spolu",
          description: "Internet + TV + Telefón"
        };
        cards.push({
          product: comboProduct,
          typeKey: "combo",
          isCombo: true
        });
        hasComboCard = true;
      }

      if (!cards.length && !planned.length) {
        setResultsPlaceholder("V tejto lokalite momentálne neevidujeme dostupné služby.");
        return;
      }

      const cardsWithFlags = cards.map((card) => card);

      function createCardHtml(card, hasComboCardLocal) {
        const product = card.product;
        const typeKey = card.typeKey;
        const isCombo = card.isCombo;

        let iconUrl = "";
        let iconClass = "";
        let fallbackText = "";

        if (typeKey === "combo") {
          iconUrl = iconUrlMap.combo;
          iconClass = "dostupnost-icon-combo";
          fallbackText = "ALL";
        } else if (typeKey === "internet") {
          iconUrl = getIconForProduct(product);
          iconClass = "dostupnost-icon-internet";
          fallbackText = "NET";
        } else if (typeKey === "phone") {
          iconUrl = getIconForProduct(product);
          iconClass = "dostupnost-icon-phone";
          fallbackText = "TEL";
        } else if (typeKey === "tv") {
          iconUrl = getIconForProduct(product) || iconUrlMap.tv;
          iconClass = "dostupnost-icon-tv";
          fallbackText = "TV";
        } else if (typeKey === "sat") {
          iconUrl = getIconForProduct(product) || iconUrlMap.sat;
          iconClass = "dostupnost-icon-sat";
          fallbackText = "SAT";
        }

        const name = product && product.name ? product.name : "";
        const desc = product && product.description ? product.description : "";

        const iconInner = iconUrl
          ? `<img src="${iconUrl}" alt="${name || fallbackText}">`
          : fallbackText;

        // širšie boxy pre TV/SAT, keď NIE je combo (len samostatné služby)
        const wideClass =
          !hasComboCardLocal && (typeKey === "tv" || typeKey === "sat")
            ? " dostupnost-card-wide"
            : "";

        return `
          <div class="dostupnost-card ${isCombo ? "dostupnost-card-combo" : ""}${wideClass}">
            <div class="dostupnost-card-icon ${iconClass}">
              ${iconInner}
            </div>
            <div>
              <div class="dostupnost-card-name">${name}</div>
              ${
                desc
                  ? `<div class="dostupnost-card-desc">${desc}</div>`
                  : `<div class="dostupnost-card-desc">&nbsp;</div>`
              }
            </div>
            <div class="dostupnost-card-status">✓</div>
          </div>
        `;
      }

      let html = "";

      if (cardsWithFlags.length) {
        html += `<h3 class="dostupnost-results-title">Dostupné služby v mojej lokalite:</h3>`;
        html += `<div class="dostupnost-results-row">`;

        if (hasComboCard) {
          // 3P scenár – len karty, jedno tlačidlo dole
          cardsWithFlags.forEach((card) => {
            html += createCardHtml(card, true);
          });
          html += `</div>`;

          if (ctaUrlCombo) {
            html += `
              <div class="dostupnost-cta">
                <button type="button"
                        class="dostupnost-cta-button dostupnost-cta-button-main"
                        data-cta-url="${ctaUrlCombo}">
                  ${ctaLabel}
                </button>
              </div>
            `;
          }
        } else {
          // bez 3P – SAT a TV, každé má vlastné tlačidlo pod kartou
          cardsWithFlags.forEach((card) => {
            const typeKey = card.typeKey;
            const url = getCtaUrlForType(typeKey);

            let labelSuffix = "";
            //if (typeKey === "tv") labelSuffix = " - TV";
            //if (typeKey === "sat") labelSuffix = " - SAT";

            const buttonHtml =
              (typeKey === "tv" || typeKey === "sat") && url
                ? `
              <div class="dostupnost-cta dostupnost-cta-below-card">
                <button type="button"
                        class="dostupnost-cta-button dostupnost-cta-button-card"
                        data-cta-url="${url}">
                  ${ctaLabel}${labelSuffix}
                </button>
              </div>`
                : "";

            html += `
              <div class="dostupnost-card-wrapper">
                ${createCardHtml(card, false)}
                ${buttonHtml}
              </div>
            `;
          });

          html += `</div>`;
        }
      }

      // PLANED (čoskoro dostupné)
      if (planned.length) {
        const plannedNames = planned
          .map((p) => p.name)
          .filter(Boolean)
          .filter((value, index, self) => self.indexOf(value) === index);

        html += `<div class="dostupnost-planned">`;
        html += `<div class="dostupnost-planned-title">Čoskoro dostupné vo Vašej lokalite aj:</div>`;
        html += `<div class="dostupnost-planned-text">${plannedNames.join(", ")}</div>`;
        html += `</div>`;
      }

      dostupnostResults.innerHTML = html;

      // CTA buttony – per TV/SAT aj hlavné 3P tlačidlo
      const buttons = dostupnostResults.querySelectorAll(
        ".dostupnost-cta-button-card, .dostupnost-cta-button-main"
      );
      buttons.forEach((btn) => {
        const url = btn.dataset.ctaUrl;
        if (!url) return;
        btn.addEventListener("click", () => {
          window.location.href = url;
        });
      });
    }

    function loadAvailabilityForAddress(addressPointId) {
      if (!addressPointId) {
        setResultsPlaceholder("Najprv zadajte kompletnú adresu.");
        return;
      }

      const url =
        "https://eregister.antik.sk/api/availability/addresspoint/" +
        encodeURIComponent(addressPointId) +
        "?scope=address.products";

      fetch(url)
        .then((response) => response.json())
        .then((json) => {
          renderAvailabilityResult(json.data);
        })
        .catch((err) => {
          console.error("Chyba pri načítaní dostupnosti služieb:", err);
          setResultsPlaceholder("Pri načítaní dostupnosti nastala chyba. Skúste to prosím znova.");
        });
    }

    // --------------------------------------------------------------------
    // 1) MESTO – vyhľadávanie
    // --------------------------------------------------------------------
    dostupnostCityInput.addEventListener("input", () => {
      const query = dostupnostCityInput.value.trim();

      currentCityId = null;
      currentCityStreetCount = 0;
      currentStreetId = null;

      dostupnostCityId.value = "";
      dostupnostStreetId.value = "";
      dostupnostHouseId.value = "";

      dostupnostStreetInput.value = "";
      dostupnostHouseInput.value = "";

      dostupnostStreetInput.disabled = true;
      dostupnostHouseInput.disabled = true;

      setResultsPlaceholder("Zadajte ulicu a číslo domu na zobrazenie dostupných služieb.");

      if (citySearchTimer) clearTimeout(citySearchTimer);
      clearCitySuggestions();
      clearStreetSuggestions();
      clearHouseSuggestions();

      if (query.length < 2) return;

      citySearchTimer = setTimeout(() => {
        const url =
          "https://eregister.antik.sk/api/availability/city?search=" +
          encodeURIComponent(query) +
          "&scope=city.count_streets";

        fetch(url)
          .then((response) => response.json())
          .then((json) => {
            const data = json.data || [];
            if (!data.length) return;

            dostupnostCitySuggestions.innerHTML = "";

            data.forEach((city) => {
              let countyLabel = "";
              if (typeof city.county === "string") {
                countyLabel = city.county;
              } else if (city.county && typeof city.county === "object") {
                countyLabel = city.county.name || city.county.title || "";
              }

              const li = createSuggestionItem(
                city.name,
                countyLabel ? `Okres: ${countyLabel}` : ""
              );

              li.addEventListener("click", () => {
                dostupnostCityInput.value = city.name;
                dostupnostCityId.value = city.id;

                currentCityId = city.id;

                const rawStreetCount =
                  city.street_count !== undefined
                    ? city.street_count
                    : city.streets_count !== undefined
                    ? city.streets_count
                    : 0;

                currentCityStreetCount = Number(rawStreetCount || 0);
                currentStreetId = null;

                clearCitySuggestions();
                clearStreetSuggestions();
                clearHouseSuggestions();

                if (currentCityStreetCount > 0) {
                  dostupnostStreetInput.disabled = false;
                  dostupnostHouseInput.disabled = true;
                  dostupnostStreetInput.focus();
                } else {
                  dostupnostStreetInput.disabled = true;
                  dostupnostHouseInput.disabled = false;
                  dostupnostHouseInput.focus();
                }

                setResultsPlaceholder("Zadajte ulicu a číslo domu na zobrazenie dostupných služieb.");
              });

              dostupnostCitySuggestions.appendChild(li);
            });

            dostupnostCitySuggestions.style.display = "block";
          })
          .catch((err) => {
            console.error("Chyba pri načítaní miest:", err);
          });
      }, 300);
    });

    // --------------------------------------------------------------------
    // 2) ULICA – vyhľadávanie
    // --------------------------------------------------------------------
    dostupnostStreetInput.addEventListener("input", () => {
      const query = dostupnostStreetInput.value.trim();

      dostupnostStreetId.value = "";
      currentStreetId = null;
      dostupnostHouseId.value = "";
      dostupnostHouseInput.value = "";
      dostupnostHouseInput.disabled = true;

      if (!currentCityId || currentCityStreetCount <= 0) {
        return;
      }

      if (streetSearchTimer) clearTimeout(streetSearchTimer);
      clearStreetSuggestions();
      clearHouseSuggestions();

      if (query.length < 2) return;

      streetSearchTimer = setTimeout(() => {
        const url =
          "https://eregister.antik.sk/api/availability/city/" +
          encodeURIComponent(currentCityId) +
          "/street?search=" +
          encodeURIComponent(query) +
          "&scope=street.districts";

        fetch(url)
          .then((response) => response.json())
          .then((json) => {
            const data = json.data || [];
            if (!data.length) return;

            dostupnostStreetSuggestions.innerHTML = "";

            data.forEach((street) => {
              let districtNames = [];
              if (Array.isArray(street.districts)) {
                const set = new Set();
                street.districts.forEach((district) => {
                  if (district && district.name && !set.has(district.name)) {
                    set.add(district.name);
                  }
                });
                districtNames = Array.from(set);
              }

              const secondaryText = districtNames.length
                ? "Časť: " + districtNames.join(", ")
                : "";

              const li = createSuggestionItem(street.name, secondaryText);

              li.addEventListener("click", () => {
                dostupnostStreetInput.value = street.name;
                dostupnostStreetId.value = street.id;
                currentStreetId = street.id;

                clearStreetSuggestions();
                clearHouseSuggestions();

                dostupnostHouseInput.disabled = false;
                dostupnostHouseInput.focus();

                setResultsPlaceholder("Zadajte číslo domu na zobrazenie dostupných služieb.");
              });

              dostupnostStreetSuggestions.appendChild(li);
            });

            dostupnostStreetSuggestions.style.display = "block";
          })
          .catch((err) => {
            console.error("Chyba pri načítaní ulíc:", err);
          });
      }, 300);
    });

    // --------------------------------------------------------------------
    // 3) ČÍSLO DOMU – vyhľadávanie
    // --------------------------------------------------------------------
    dostupnostHouseInput.addEventListener("input", () => {
      const query = dostupnostHouseInput.value.trim();

      dostupnostHouseId.value = "";

      if (!currentCityId) return;

      if (houseSearchTimer) clearTimeout(houseSearchTimer);
      clearHouseSuggestions();

      if (!query) return;

      houseSearchTimer = setTimeout(() => {
        let url =
          "https://eregister.antik.sk/api/availability/city/" +
          encodeURIComponent(currentCityId) +
          "/addresspoint?search=" +
          encodeURIComponent(query) +
          "&scope=city.detial";

        if (currentStreetId) {
          url += "&street_id=" + encodeURIComponent(currentStreetId);
        }

        fetch(url)
          .then((response) => response.json())
          .then((json) => {
            const data = json.data || [];
            if (!data.length) return;

            dostupnostHouseSuggestions.innerHTML = "";

            data.forEach((address) => {
              const houseNumber =
                address.name ||
                address.house_number ||
                address.number ||
                address.descriptive_number ||
                "";

              const streetName =
                (address.street && address.street.name) ||
                address.street_name ||
                dostupnostStreetInput.value ||
                "";

              const districtName =
                (address.district && address.district.name) ||
                address.district_name ||
                "";

              let secondaryParts = [];
              if (streetName) secondaryParts.push(streetName);
              if (districtName) secondaryParts.push(districtName);

              const secondaryText = secondaryParts.join(" · ");

              const li = createSuggestionItem(
                houseNumber || "(bez čísla)",
                secondaryText
              );

              li.addEventListener("click", () => {
                if (houseNumber) {
                  dostupnostHouseInput.value = houseNumber;
                }
                dostupnostHouseId.value = address.id || "";
                clearHouseSuggestions();

                if (address.id) {
                  loadAvailabilityForAddress(address.id);
                } else {
                  setResultsPlaceholder("Nepodarilo sa načítať ID adresného bodu.");
                }
              });

              dostupnostHouseSuggestions.appendChild(li);
            });

            dostupnostHouseSuggestions.style.display = "block";
          })
          .catch((err) => {
            console.error("Chyba pri načítaní čísel domov:", err);
          });
      }, 300);
    });

    // Klik mimo dropdownov → schovať všetky
    document.addEventListener("click", (event) => {
      if (!section.contains(event.target)) {
        clearCitySuggestions();
        clearStreetSuggestions();
        clearHouseSuggestions();
      }
    });
  });
})();